import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "../components/Access";
import Navbar from "../components/Navbar";
import { ReactComponent as Add } from '../Img/icon-add.svg';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Dialog from "../components/Dialog";

const ModalitesPortage = (props) =>
{
    const [modalVisible, setModalVisible] = useState(false);
    const [modalites, setModalites] = useState([]);
    const [id_organisme, setId_organisme] = useState('');
    const [intitule, setIntitule] = useState('');
    const [taux, setTaux] = useState('');
    const [commentaire, setCommentaire] = useState('');

    // édition / suppression
    const [editingModalite, setEditingModalite] = useState(null); // null => création

    // Dialog confirmation component (utilisé par le bouton Supprimer)
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    // tri
    const [sortField, setSortField] = useState(null); // 'intitule' | 'taux' | 'commentaire'
    const [sortOrder, setSortOrder] = useState('asc');

    const purple = '#6571FE';
    const green = '#59B44A';

    // callback pour le Dialog central (utilisé ailleurs)
    async function callbackDialog(ret) {
        if (ret === true) {
            await deleteModaliteConfirmed();
        }
    }

    async function mount()
    {
        if (props.user && props.user.id_organisme) {
            setId_organisme(String(props.user.id_organisme));
            const params = {
                get: true,
                id_organisme: props.user.id_organisme
            };
            try {
                const res = await axios.post('/api/modalites_portage.php', qs.stringify(params));
                if (res && res.data) {
                    const list = Array.isArray(res.data) ? res.data : (res.data.data ? res.data.data : []);
                    setModalites(list || []);
                } else {
                    setModalites([]);
                }
            } catch (err) {
                console.warn(err);
                setModalites([]);
            }
        }
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        } else {
            mount();
        }
    }, [props.user]);

    useEffect(() => {
        document.body.style.overflow = modalVisible ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [modalVisible]);

    useEffect(() => {
        function onKey(e) {
            if (e.key === 'Escape') {
                setModalVisible(false);
                clearForm();
            }
        }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const clearForm = () => {
        setId_organisme(props.user && props.user.id_organisme ? String(props.user.id_organisme) : '');
        setIntitule('');
        setTaux('');
        setCommentaire('');
        setCommentaire('');
        setEditingModalite(null);
    };

    const openCreateModal = () => {
        clearForm();
        setModalVisible(true);
    };

    const openEditModal = (m) => {
        setEditingModalite(m);
        setId_organisme(m.id_organisme ? String(m.id_organisme) : (props.user && props.user.id_organisme ? String(props.user.id_organisme) : ''));
        setIntitule(m.intitule || '');
        setTaux(m.taux !== null && m.taux !== undefined ? String(m.taux) : '');
        // legacy: duree removed from schema; keep commentaire instead
        setCommentaire(m.commentaire || '');
        setModalVisible(true);
    };

    const validateIntitule = () => {
        if (!intitule || !intitule.trim()) {
            setDialogMessage("Le champ « Intitulé » est requis.");
            setDialogOpen(true);
            return false;
        }
        return true;
    };

    const createModalite = async () => {
        if (!validateIntitule()) return;
        try {
            const params = {
                create: true,
                id_organisme: id_organisme,
                intitule: intitule,
                taux: taux,
                commentaire: commentaire
            };
            const res = await axios.post('/api/modalites_portage.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Modalité créée.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur création modalité';
                NotificationManager.error(msg, '', 4000);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de création.", '', 4000);
            console.error(e);
        }
    };

    const updateModalite = async () => {
        if (!editingModalite || !editingModalite.id) return;
        if (!validateIntitule()) return;
        try {
            const params = {
                update: true,
                id: editingModalite.id,
                id_organisme: id_organisme,
                intitule: intitule,
                taux: taux,
                commentaire: commentaire
            };
            const res = await axios.post('/api/modalites_portage.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Modalité mise à jour.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur mise à jour modalité';
                NotificationManager.error(msg, '', 4000);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de mise à jour.", '', 4000);
            console.error(e);
        }
    };

    // ouverture confirmation suppression (Dialog central utilisé)
    const requestDeleteModalite = () => {
        if (!editingModalite || !editingModalite.id) return;
        // utilise le Dialog exporté (callbackDialog appellera deleteModaliteConfirmed)
        setDialogModalVisible(true);
    };

    const deleteModaliteConfirmed = async () => {
        if (!editingModalite || !editingModalite.id) return;
        try {
            const params = {
                delete: true,
                id: editingModalite.id
            };
            const res = await axios.post('/api/modalites_portage.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Modalité supprimée.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur suppression modalité';
                NotificationManager.error(msg, '', 4000);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de suppression.", '', 4000);
            console.error(e);
        }
    };

    // tri
    const getFieldValue = (m, field) => {
        switch (field) {
            case 'intitule': return (m.intitule || '').toString().toLowerCase();
            case 'taux': return parseFloat(m.taux || 0);
            case 'commentaire': return (m.commentaire || '').toString().toLowerCase();
            default: return '';
        }
    };
    const onHeaderClick = (field) => {
        const nextOrder = (sortField === field && sortOrder === 'asc') ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(nextOrder);
        setModalites(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const va = getFieldValue(a, field);
                const vb = getFieldValue(b, field);
                if (va === vb) return 0;
                if (typeof va === 'string') {
                    return nextOrder === 'asc' ? (va > vb ? 1 : -1) : (va < vb ? 1 : -1);
                } else {
                    return nextOrder === 'asc' ? (va - vb) : (vb - va);
                }
            });
            return copy;
        });
    };

    return (
        <div>
            <Access needConnection={true} type_user={[1, 2]}>
                <Navbar user={props.user} />
                <NotificationContainer />

                {/* Dialog central utilisé */}
                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                {/* Dialog d'erreur simple */}
                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} title="Erreur">
                    <div>{dialogMessage}</div>
                </Dialog>

                <div style={{display: 'flex', margin: 25}}>
                    <p>Gestion \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Modalités de portage</p>
                    <div style={{flex: 1}}></div>
                    <button
                        className='shadow-md rounded-md'
                        style={{backgroundColor: green, color: 'white', marginLeft: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}
                        onClick={openCreateModal}>
                        <Add width="12"/>
                        <p style={{marginLeft: 5}}>Nouvelle modalité</p>
                    </button>
                </div>

                {/* POPUP création / édition */}
                {modalVisible &&
                    <div
                        onClick={() => { setModalVisible(false); clearForm(); }}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            role="dialog"
                            aria-modal="true"
                            style={{
                                width: 560,
                                maxWidth: '95%',
                                backgroundColor: 'white',
                                borderRadius: 8,
                                padding: 20,
                                boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                                textAlign: 'left'
                            }}
                        >
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
                                <p style={{margin: 0, fontSize: 18}}>{editingModalite ? 'Modifier la modalité' : 'Créer une modalité'}</p>
                                <button onClick={() => { setModalVisible(false); clearForm(); }} style={{border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18}}>✕</button>
                            </div>

                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                                <div style={{width: '100%'}}>
                                    <p style={{display: 'block', marginBottom: 6}}>Intitulé</p>
                                    <input value={intitule} onChange={e => setIntitule(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Intitulé" />
                                </div>

                                <div style={{flex: '100%', minWidth: 160}}>
                                    <p style={{display: 'block', marginBottom: 6}}>Taux (%)</p>
                                    <input value={taux} onChange={e => setTaux(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: 12.5" />
                                </div>

                                <div style={{flex: '100%', minWidth: 160}}>
                                    <p style={{display: 'block', marginBottom: 6}}>Commentaire</p>
                                    <textarea value={commentaire} onChange={e => setCommentaire(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ajouter un commentaire" rows={3} />
                                </div>
                            </div>

                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14}}>
                                <button
                                    onClick={() => { setModalVisible(false); clearForm(); }}
                                    style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#eee', border: 'none', cursor: 'pointer'}}
                                >
                                    Annuler
                                </button>

                                {editingModalite ? (
                                    <>
                                        <button
                                            onClick={() => { setModalVisible(false); setDialogModalVisible(true); }}
                                            style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#d9534f', color: 'white', border: 'none', cursor: 'pointer'}}
                                        >
                                            Supprimer
                                        </button>
                                        <button
                                            onClick={updateModalite}
                                            style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#f0ad4e', color: 'white', border: 'none', cursor: 'pointer'}}
                                        >
                                            Mettre à jour
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        onClick={createModalite}
                                        style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                                    >
                                        Créer
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                }

                {/* Listing des modalités */}
                <div style={{margin: 25}}>
                    {(() => {
                        const list = Array.isArray(modalites) ? modalites : (modalites && modalites.data ? modalites.data : []);
                        if (!list || list.length === 0) {
                            return <p style={{color: '#666'}}>Aucune modalité pour cet organisme.</p>;
                        }
                        return (
                            <>
                                {/* En-tête */}
                                <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                    <p style={{flex:6, minWidth:0, cursor:'pointer', margin: 0}} onClick={() => onHeaderClick('intitule')}>
                                        Intitulé {sortField === 'intitule' && (sortOrder === 'asc' ? '▲' : '▼')}
                                    </p>
                                    <p style={{flex:2, minWidth:100, textAlign:'center', cursor:'pointer', margin: 0}} onClick={() => onHeaderClick('taux')}>
                                        Taux {sortField === 'taux' && (sortOrder === 'asc' ? '▲' : '▼')}
                                    </p>
                                    <p style={{flex:2, minWidth:100, textAlign:'center', cursor:'pointer', margin: 0}} onClick={() => onHeaderClick('commentaire')}>
                                        Commentaire {sortField === 'commentaire' && (sortOrder === 'asc' ? '▲' : '▼')}
                                    </p>
                                </div>

                                {/* Liste en boutons */}
                                <div style={{display:'flex', flexDirection:'column', gap:8, marginTop:8}}>
                                    {list.map(m => (
                                        <button
                                            key={m.id}
                                            onClick={() => openEditModal(m)}
                                            style={{
                                                display: 'flex',
                                                width: '100%',
                                                textAlign: 'left',
                                                padding: '12px',
                                                borderRadius: 6,
                                                border: '1px solid #eee',
                                                background: 'white',
                                                cursor: 'pointer',
                                                alignItems: 'center',
                                                gap: 12
                                            }}
                                        >
                                            <div style={{flex:6, minWidth:0}}>
                                                <p style={{margin: 0}}>{m.intitule || ''}</p>
                                            </div>

                                            <p style={{flex:2, minWidth:100, textAlign:'center', margin: 0}}>
                                                {m.taux !== null && m.taux !== undefined ? m.taux : ''}
                                            </p>

                                            <p style={{flex:2, minWidth:100, textAlign:'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: 0}}>
                                                {m.commentaire !== null && m.commentaire !== undefined ? m.commentaire : ''}
                                            </p>
                                        </button>
                                    ))}
                                </div>
                            </>
                        );
                    })()}
                </div>

            </Access>
        </div>
    );
}

export default ModalitesPortage;
